module.exports = __webpack_public_path__ + "static/JudyLucille-2f02694560aa62b7eb55ea5f30e06055.jpg";